import React from 'react';
import MuiTableCell from '@mui/material/TableCell';

const TableCell = (props) => <MuiTableCell {...props} />;

export default TableCell;
